import { Col, Form, FormGroup, Input, Label, Row } from "reactstrap";
import { AgreeTerms, ConfirmPassword, EmailAddress, FirstName, Password } from "../../../../../../constants";
import { InfoFormProps } from "../../../../../../types/Forms";

const BasicInfoForm: React.FC<InfoFormProps> = ({ register, errors, updateFormData, formData }) => {
  return (
    <Form className="needs-validation custom-input" noValidate>
      <Row className="g-3">
        <Col sm="6">
          <Label>{EmailAddress}<span className="txt-danger">{"*"}</span></Label>
          <Input {...register("email", { required: "Email is required" })} value={formData.email} type="email" placeholder="zono@gmail.com" onChange={updateFormData} />
          {errors.email && <span className="text-danger">{errors.email.message}</span>}
        </Col>
        <Col sm="6">
          <Label>{FirstName}<span className="txt-danger">{"*"}</span></Label>
          <Input {...register("firstName", { required: "First name is required" })} value={formData.firstName} type="text" placeholder="Enter your name" onChange={updateFormData} />
          {errors.firstName && <span className="text-danger">{errors.firstName.message}</span>}
        </Col>
        <Col xs="12">
          <Col sm="12">
            <Label>{Password}<span className="txt-danger">{"*"}</span></Label>
          </Col>
          <Input {...register("password", { required: "Password is required" })} value={formData.password} type="password" placeholder="Enter password" onChange={updateFormData} autoComplete="off" />
          {errors.password && <span className="text-danger">{errors.password.message}</span>}
        </Col>
        <Col xs="12">
          <Col sm="12">
            <Label>{ConfirmPassword}<span className="txt-danger">{"*"}</span></Label>
          </Col>
          <Input {...register("confirmPassword", { required: "Confirm password is required" })} value={formData.confirmPassword} type="password" placeholder="Enter confirm password" autoComplete="off" onChange={updateFormData} />
          {errors.confirmPassword && <span className="text-danger">{errors.confirmPassword.message}</span>}
        </Col>
        <Col xs="12">
          <FormGroup check>
            <Input id="inputCheckWizard" {...register("agreeTerms", { required: true })} type="checkbox" onChange={updateFormData} required/>
            <Label className="mb-0" htmlFor="inputCheckWizard" check>{AgreeTerms}</Label>
          </FormGroup>
        </Col>
      </Row>
    </Form>
  );
};
export default BasicInfoForm;
